<div class="custom-satisfaction-container" *ngIf="!isLoadingLabels">
	<div *ngIf="isManagement">
		<cpi-msp-table
			[header]="searchHeader"
			[body]="customSatisfactionList"
			[height]="'55dvh'"
			[itemPadding]="'1%'"
			[labels]="labels"
			[insideSort]="true"
			(getSelectedItem)="openUpdatedForm($event[0])">
		</cpi-msp-table>
		<div class="button-container">
			<div class="button" (click)="openForm(form)">{{ labels.lbl_geral_novo }}</div>
		</div>
	</div>

	<div class="header-wrap" *ngIf="!isManagement">
		<span class="tab" [ngClass]="{ selected: selectedTab === 'create' }" (click)="selectedTab = 'create'" *ngIf="showForm">{{
			labels.lbl_kb_criar
		}}</span>
		<span class="tab" [ngClass]="{ selected: selectedTab === 'edit' }" (click)="selectedTab = 'edit'" *ngIf="showEditForm">{{
			labels.lbl_geral_editar
		}}</span>
	</div>
	<div class="body-wrap" *ngIf="!isManagement">
		<ng-container *ngIf="selectedTab === 'edit'">
			<div *ngIf="showEditForm">
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_pergunta }}*</span>
					<input
						id="question"
						name="question"
						type="text"
						[(ngModel)]="formUpdate.question"
						placeholder="{{ labels.lbl_geral_pergunta }}" />
				</div>

				<span class="responses-font-color"
					>{{ labels.lbl_geral_responses }}
					<fa-icon [icon]="icons.faInfoCircle" [title]="labels.lbl_escreva_duas_opcoes_de_resposta"></fa-icon
				></span>
				<div class="responses-container">
					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_resposta }} 1*</span>
						<input
							id="option1"
							name="option1"
							type="text"
							[(ngModel)]="formUpdate.question_options.option1"
							placeholder=" {{ labels.lbl_geral_resposta }} 1" />
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_resposta }} 2*</span>
						<input
							id="option2"
							name="option2"
							type="text"
							[(ngModel)]="formUpdate.question_options.option2"
							placeholder=" {{ labels.lbl_geral_resposta }} 2" />
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_resposta }} 3</span>
						<input
							id="option3"
							name="option3"
							type="text"
							[(ngModel)]="formUpdate.question_options.option3"
							placeholder=" {{ labels.lbl_geral_resposta }} 3" />
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_resposta }} 4</span>
						<input
							id="option4"
							name="option4"
							type="text"
							[(ngModel)]="formUpdate.question_options.option4"
							placeholder=" {{ labels.lbl_geral_resposta }} 4" />
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_resposta }} 5</span>
						<input
							id="option5"
							name="option5"
							type="text"
							[(ngModel)]="formUpdate.question_options.option5"
							placeholder=" {{ labels.lbl_geral_resposta }} 5" />
					</div>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_comentario }}*</span>
					<cpi-checkbox
						[value]="formUpdate.comment"
						(oValue)="formUpdate.comment = $event"
						[innerText]="formUpdate.comment ? labels.lbl_geral_sim : labels.lbl_geral_nao">
					</cpi-checkbox>
				</div>

				<div class="button-container">
					<div class="button" [ngClass]="{ disabled: isUpdating }" (click)="updateCustomSatisfaction(formUpdate)">
						{{ labels.lbl_geral_atualizar }}
						<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdating"></cpi-dot-bounce-loading-effect>
					</div>
					<div
						class="button"
						(click)="
							deleteListRef.classList.contains('confirm')
								? deleteCustomSatisfaction(formUpdate.id)
								: confirmButton(deleteListRef)
						"
						#deleteListRef>
						{{ labels.lbl_geral_excluir }}
					</div>
					<div class="button" (click)="backManagement()">{{ labels.lbl_geral_voltar }}</div>
				</div>
			</div>
		</ng-container>

		<ng-container *ngIf="selectedTab === 'create'">
			<div *ngIf="showForm">
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_pergunta }}*</span>
					<input
						id="question"
						name="question"
						type="text"
						[(ngModel)]="form.question"
						placeholder="{{ labels.lbl_geral_pergunta }}" />
				</div>

				<span class="responses-font-color"
					>{{ labels.lbl_geral_responses }}
					<fa-icon [icon]="icons.faInfoCircle" [title]="labels.lbl_escreva_duas_opcoes_de_resposta"></fa-icon
				></span>
				<div class="responses-container">
					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_resposta }} 1*</span>
						<input
							id="option1"
							name="option1"
							type="text"
							[(ngModel)]="form.question_options.option1"
							placeholder=" {{ labels.lbl_geral_resposta }} 1" />
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_resposta }} 2*</span>
						<input
							id="option2"
							name="option2"
							type="text"
							[(ngModel)]="form.question_options.option2"
							placeholder=" {{ labels.lbl_geral_resposta }} 2" />
					</div>

					<div class="dotted-input-container" *ngIf="showOption3">
						<span>{{ labels.lbl_geral_resposta }} 3</span>
						<input
							id="option3"
							name="option3"
							type="text"
							[(ngModel)]="form.question_options.option3"
							placeholder=" {{ labels.lbl_geral_resposta }} 3" />
					</div>

					<div class="dotted-input-container" *ngIf="showOption4">
						<span>{{ labels.lbl_geral_resposta }} 4</span>
						<input
							id="option4"
							name="option4"
							type="text"
							[(ngModel)]="form.question_options.option4"
							placeholder=" {{ labels.lbl_geral_resposta }} 4" />
					</div>

					<div class="dotted-input-container" *ngIf="showOption5">
						<span>{{ labels.lbl_geral_resposta }} 5</span>
						<input
							id="option5"
							name="option5"
							type="text"
							[(ngModel)]="form.question_options.option5"
							placeholder=" {{ labels.lbl_geral_resposta }} 5" />
					</div>

					<fa-icon
						class="responses-font-color"
						[title]="labels.lbl_clicar_para_expandir_mais_um_campo_de_resposta"
						*ngIf="showAddIcon"
						[icon]="icons.faPlus"
						(click)="toggleNextOptionForm()"></fa-icon>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_comentario }}*</span>
					<cpi-checkbox
						[value]="form.comment"
						(oValue)="form.comment = $event"
						[innerText]="form.comment ? labels.lbl_geral_sim : labels.lbl_geral_nao">
					</cpi-checkbox>
				</div>

				<div class="button-container">
					<div class="button" [ngClass]="{ disabled: isUpdating }" (click)="createCustomSatisfaction(form)">
						{{ labels.lbl_geral_salvar }}
						<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdating"></cpi-dot-bounce-loading-effect>
					</div>
					<div class="button" (click)="backManagement()">{{ labels.lbl_geral_voltar }}</div>
				</div>
			</div>
		</ng-container>

		<cpi-dot-bounce-loading-effect *ngIf="isLoadingSatisfaction" [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
	</div>
</div>

<cpi-dot-bounce-loading-effect *ngIf="isLoadingLabels" [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
